/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { OasDocument } from '../../openapi/models/OasDocument';
import { OasPathItem } from '../../openapi/models/OasPathItem';

/**
 * A command used to add a new pathItem in a document.  Source for the new
 * pathItem must be provided.  This source will be converted to an OAS
 * pathItem object and then added to the data model.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class AddPathItemCommand extends AbstractCommand {
    public _pathItemExists : boolean;

    public _newPathItemName : string;

    public _newPathItemObj : any;

    public _nullPathItems : boolean;

    public constructor(pathItemName? : any, from? : any) {
        if(((typeof pathItemName === 'string') || pathItemName === null) && ((from != null) || from === null)) {
            let __args = arguments;
            super();
            if(this._pathItemExists===undefined) this._pathItemExists = false;
            if(this._newPathItemName===undefined) this._newPathItemName = null;
            if(this._newPathItemObj===undefined) this._newPathItemObj = null;
            if(this._nullPathItems===undefined) this._nullPathItems = false;
            if(this._pathItemExists===undefined) this._pathItemExists = false;
            if(this._newPathItemName===undefined) this._newPathItemName = null;
            if(this._newPathItemObj===undefined) this._newPathItemObj = null;
            if(this._nullPathItems===undefined) this._nullPathItems = false;
            (() => {
                this._newPathItemName = pathItemName;
                this._newPathItemObj = from;
            })();
        } else if(((typeof pathItemName === 'string') || pathItemName === null) && from === undefined) {
            let __args = arguments;
            super();
            if(this._pathItemExists===undefined) this._pathItemExists = false;
            if(this._newPathItemName===undefined) this._newPathItemName = null;
            if(this._newPathItemObj===undefined) this._newPathItemObj = null;
            if(this._nullPathItems===undefined) this._nullPathItems = false;
            if(this._pathItemExists===undefined) this._pathItemExists = false;
            if(this._newPathItemName===undefined) this._newPathItemName = null;
            if(this._newPathItemObj===undefined) this._newPathItemObj = null;
            if(this._nullPathItems===undefined) this._nullPathItems = false;
            (() => {
                this._newPathItemName = pathItemName;
            })();
        } else if(pathItemName === undefined && from === undefined) {
            let __args = arguments;
            super();
            if(this._pathItemExists===undefined) this._pathItemExists = false;
            if(this._newPathItemName===undefined) this._newPathItemName = null;
            if(this._newPathItemObj===undefined) this._newPathItemObj = null;
            if(this._nullPathItems===undefined) this._nullPathItems = false;
            if(this._pathItemExists===undefined) this._pathItemExists = false;
            if(this._newPathItemName===undefined) this._newPathItemName = null;
            if(this._newPathItemObj===undefined) this._newPathItemObj = null;
            if(this._nullPathItems===undefined) this._nullPathItems = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[AddPathItemCommand] Executing.");
        let doc : OasDocument = <OasDocument>document;
        if(this.isNullOrUndefined(doc.paths)) {
            doc.paths = doc.createPaths();
            this._nullPathItems = true;
        }
        if(!this.isNullOrUndefined(doc.paths.getPathItem(this._newPathItemName))) {
            LoggerCompat.info("[AddPathItemCommand] PathItem with name %s already exists.", this._newPathItemName);
            this._pathItemExists = true;
        } else {
            let pathItem : OasPathItem = doc.paths.createPathItem(this._newPathItemName);
            Library.readNode(this._newPathItemObj, pathItem);
            doc.paths.addPathItem(this._newPathItemName, pathItem);
            this._pathItemExists = false;
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[AddPathItemCommand] Reverting.");
        if(this._pathItemExists) {
            return;
        }
        let doc : OasDocument = <OasDocument>document;
        if(this._nullPathItems) {
            doc.paths = null;
        } else {
            doc.paths.removePathItem(this._newPathItemName);
        }
    }
}
AddPathItemCommand["__class"] = "io.apicurio.datamodels.cmd.commands.AddPathItemCommand";
AddPathItemCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];





import { MarshallCompat } from '../../compat/MarshallCompat';

